import { DateTime, DateTimeMaybeValid, Duration, DurationMaybeValid, Interval, IntervalMaybeValid } from 'luxon';

interface MaybeValid {
  isValid: boolean;
  invalidReason: null | string;
  invalidExplanation: null | string;
}

// Define Valid to match luxon's type constraint
// Luxon uses true as a branded type for valid DateTime/Duration/Interval instances
export type Valid = true;

export function assertValid(dateTime: DateTimeMaybeValid): DateTime<Valid>;
export function assertValid(duration: DurationMaybeValid): Duration<Valid>;
export function assertValid(interval: IntervalMaybeValid): Interval<Valid>;
export function assertValid(val: MaybeValid): MaybeValid {
  if (!val.isValid) {
    throw new Error(`Invalid ${val.constructor.name}: ${val.invalidReason}: ${val.invalidExplanation}`);
  }
  return val;
}
